export default __webpack_public_path__ + "static/webassembly-logo-horizontal-6a4f5fcdf39c83ebec4939335d7fbb99.webp";